export default __webpack_public_path__ + "static/media/740.0eb1d7f4.png";